import { render, staticRenderFns } from "./PhoneUnsupportedState.vue?vue&type=template&id=1a4b3c51&scoped=true"
import script from "./PhoneUnsupportedState.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneUnsupportedState.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneUnsupportedState.vue?vue&type=style&index=0&id=1a4b3c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b3c51",
  null
  
)

export default component.exports